
    import "src/app/AppAdmin/Brands/Products/index.module.scss?farm_css_modules";
    
    export default {"skuDetail": `skuDetail-e37ec969`,"sub": `sub-e37ec969`,"wrapper": `wrapper-e37ec969`}
    